import { baseUrl, httpClient } from '../providers/AppDataProvider';

export type RescanStatus = 'PENDING' | 'RPC_FAILED' | 'PARSE_FAILED' | 'PUBLISH_FAILED' | 'SUCCESS';

export interface RescanHistoryItem {
  id: string;
  txHash: string;
  chainId: number;
  adminTimestamp: string;
  status: RescanStatus;
  messageId: string;
  eventChannel: string;
  blockHash: string;
  blockNumber: string;
  timestamp: string;
  logCount: number;
  createdAtUnixMs: string;
  updatedAtUnixMs: string;
  errorMsg: string;
  meta: any[];
}

export interface ListRescanHistoryParams {
  page?: number;
  pageSize?: number;
  txHash?: string;
  chainId?: number;
  status?: RescanStatus;
}

export interface ListRescanHistoryResult {
  items: RescanHistoryItem[];
  total: number;
}

export async function listRescanHistory(
  params: ListRescanHistoryParams = {}
): Promise<ListRescanHistoryResult> {
  const query = new URLSearchParams();
  query.set('page', String(params.page ?? 1));
  query.set('pageSize', String(params.pageSize ?? 20));
  if (params.txHash) query.set('txHash', params.txHash);
  if (params.chainId !== undefined) query.set('chainId', String(params.chainId));
  if (params.status) query.set('status', params.status);

  const { json } = await httpClient(`${baseUrl}/xbit-relay/onchain-transactions/rescan-history?${query.toString()}`);
  return {
    items: json?.items ?? [],
    total: parseInt(json?.total ?? '0', 10),
  };
}

export interface RescanTransactionBody {
  tx_hash: string;
  chain_id: number;
  timestamp: number;
}

export async function rescanTransaction(body: RescanTransactionBody): Promise<any> {
  const { json } = await httpClient(`${baseUrl}/xbit-relay/onchain-transactions/rescan`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
  return json;
}

export const RESCAN_STATUS_CHOICES: RescanStatus[] = [
  'PENDING',
  'RPC_FAILED',
  'PARSE_FAILED',
  'PUBLISH_FAILED',
  'SUCCESS',
];
